import {
  type CustomComponents,
  DayPicker as ReactDayPicker,
  type Matcher,
} from 'react-day-picker';
import { format } from 'date-fns';
import enUs from 'date-fns/locale/en-US';

import { cls } from '@/utils/cls';

export type DisabledDates = Matcher | Matcher[];

export type DayPickerProps = {
  value: Date | undefined;
  onSelect: (value: Date | undefined) => void;
  showOutsideDays?: boolean;
  disabled?: DisabledDates;
  className?: string;
  components?: Pick<CustomComponents, 'Day'>;
};

export function DayPicker({
  value,
  onSelect,
  showOutsideDays = true,
  disabled,
  className,
  components,
}: DayPickerProps) {
  return (
    <ReactDayPicker
      mode="single"
      captionLayout="dropdown-buttons"
      locale={enUs}
      ISOWeek
      showOutsideDays={showOutsideDays}
      disabled={disabled}
      selected={value}
      defaultMonth={value}
      onSelect={(_, selectedDay) => onSelect(selectedDay)}
      classNames={{
        root: cls('w-full', className),
        months: `w-full flex flex-col p-4 gap-4`,
        month: ``,
        multiple_months: ``,
        with_weeknumber: ``,
        vhidden: ``,
        button_reset: ``,
        button: ``,
        caption: `relative text-center`,
        caption_start: ``,
        caption_end: ``,
        caption_between: ``,
        caption_label: `text-neutral-700`,
        caption_dropdowns: ``,
        dropdown: ``,
        dropdown_month: ``,
        dropdown_year: ``,
        dropdown_icon: ``,
        table: ``,
        tbody: ``,
        tfoot: ``,
        head: ``,
        head_row: ``,
        head_cell: `py-3 pt-4 text-neutral-700 text-xs leading-none font-semibold`,
        nav: ``,
        nav_button: `absolute top-1/2 -translate-y-1/2 cursor-pointer`,
        nav_button_previous: `left-0`,
        nav_button_next: `right-0`,
        nav_icon: `text-neutral-700 fill-current`,
        row: ``,
        weeknumber: ``,
        cell: ``,
        day: `size-8 flex items-center justify-center text-xs leading-none cursor-pointer`,
        day_outside: `text-neutral-400`,
        day_selected: `bg-emerald-500 text-white rounded-full`,
        day_disabled: `text-neutral-200 cursor-not-allowed`,
        day_hidden: ``,
        day_range_start: ``,
        day_range_end: ``,
        day_range_middle: ``,
        day_today: ``,
      }}
      formatters={{
        formatWeekdayName: (day) => format(day, 'iiiii'),
      }}
      components={components}
    />
  );
}
